import { render, staticRenderFns } from "./Necklace.vue?vue&type=template&id=493cc3a0&scoped=true"
import script from "./Necklace.vue?vue&type=script&lang=js"
export * from "./Necklace.vue?vue&type=script&lang=js"
import style0 from "./Necklace.vue?vue&type=style&index=0&id=493cc3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493cc3a0",
  null
  
)

export default component.exports